<template>
<!--  <div v-if="visible" class="error-page">-->
<!--    <div class="error-content">-->
<!--      <img  src="@/assets/404.png" alt="404">-->
<!--      <a-button type="primary" @click="goBack">返回首页</a-button>-->
<!--    </div>-->
<!--  </div>-->

  <div v-if="visible" class="error-content">
    <img src="@/assets/404.png" alt="404">
    <div class="error-btn-wrap">
      <a-button type="primary" @click="goBack">返回首页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    goBack() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f2f5;
}
.error-content {
  text-align: center;
}
.error-content h1 {
  font-size: 72px;
  color: #1890ff;
  margin-bottom: 24px;
}
.error-content h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 16px;
}
.error-content p {
  color: #666;
  margin-bottom: 24px;
}

.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f2f5;
}
.error-content {
  text-align: center;
  background: #4ba3c7;
  border-radius: 12px;
  padding: 0; /* 去掉内边距，让图片能完全填充 */
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;   /* 你可以根据实际需求调整宽高 */
  height: 320px;
  position: relative;
}
.error-btn-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 0;
  background: #4ba3c7;
  border-radius: 0 0 12px 12px;
}
.error-content img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保证图片填充且不变形 */
  border-radius: 12px 12px 0 0; /* 上圆角和父容器一致 */
  display: block;
}
</style>